import React, { ReactElement } from 'react';

import { Sheet } from '../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../mobile/structural/sheet/hooks/useSheet';
import TableCellAlignmentOptions from './TableCellAlignmentOptions';

import './MobileTableCellAlignmentSheet.scss';

type MobileTableCellAlignmentSheetProps = {
    sheetProps: UseSheetReturnType;
    commonTextAlignment: string | undefined;
    commonVerticalAlignment: string | undefined;
};

const MobileTableCellAlignmentSheet = ({
    sheetProps,
    commonTextAlignment,
    commonVerticalAlignment,
}: MobileTableCellAlignmentSheetProps): ReactElement => {
    return (
        <Sheet className="TableCellAlignmentSheet" {...sheetProps}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <TableCellAlignmentOptions
                        commonTextAlignment={commonTextAlignment}
                        commonVerticalAlignment={commonVerticalAlignment}
                        layout="inline"
                    />
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileTableCellAlignmentSheet;
